import { h, Fragment } from "preact";

export function LocationSuggestionsTab({ geoResults, onSelect }) {
  // Group results by country_code preserving order of first appearance
  const groupedResults = (geoResults || []).reduce((acc, result) => {
    const countryCode =
      result.country_code || result.location?.countryCode || "";
    let group = acc.find((g) => g.countryCode === countryCode);
    if (!group) {
      group = { countryCode, items: [] };
      acc.push(group);
    }
    group.items.push(result);
    return acc;
  }, []);

  const getCountryLabel = (countryCode) => {
    if (!countryCode) {
      return "";
    }
    const transKey = `locale.country.${countryCode}`;
    const translated = global.Translator?.trans
      ? global.Translator.trans(transKey, {}, "js")
      : countryCode;
    return !translated || translated === transKey ? countryCode : translated;
  };

  return (
    <div className="tab-content h-full bg-brand-100 rounded-b-md rounded-r-md">
      <div
        id="search_form_location_suggests"
        className="max-h-[300px] overflow-y-auto p-4"
      >
        <ul role="listbox">
          {groupedResults.map((group) => {
            const countryLabel = getCountryLabel(group.countryCode);
            return (
              <Fragment key={group.countryCode || "all"}>
                {group.countryCode ? (
                  <li
                    className="list-none pt-2 pb-1 px-3 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brandcopy-700 select-none"
                    key={`header-${group.countryCode}`}
                  >
                    <svg
                      className="w-4 h-4 inline-block flex-shrink-0"
                      width="16"
                      height="16"
                      aria-hidden="true"
                    >
                      <use
                        href={`/build/images/navigation-sprite.svg#flag-${group.countryCode.toLowerCase()}`}
                      ></use>
                    </svg>
                    <span>{countryLabel}</span>
                  </li>
                ) : null}
                {group.items.map((result) => (
                  <li
                    key={result.id || result.url || result.value}
                    role="option"
                  >
                    <button
                      type="button"
                      role="link"
                      onClick={() => onSelect(result)}
                      className="text-left cursor-pointer p-3 block rounded text-brandcopy-500 hover:bg-white hover:text-brandcopy-900 focus:bg-white focus:text-brandcopy-900 focus:outline-brand-500 focus:outline-2 focus:outline-offset-2 w-full block"
                    >
                      {result.value}
                    </button>
                  </li>
                ))}
              </Fragment>
            );
          })}
        </ul>
        {(!geoResults || geoResults.length === 0) && (
          <span className="alert alert--info">
            {global.Translator.trans("locationform.noresults", {}, "js")}
          </span>
        )}
      </div>
    </div>
  );
}
